import { FormattedMessage } from "react-intl";

export default function NationalTextField({
  register,
  name,
  labelId,
  error,
  type = "text",
  required = true,
}) {
  return (
    <div className="form-label row">
      <div className="col-lg-4">
        <label>
          <FormattedMessage id={labelId} />:
        </label>
      </div>
      <div className="col-lg-8">
        <div className="form-label-container">
          <input
            type={type}
            required={required}
            {...register(name)}
            className={`form-control ${error ? "is-invalid" : ""}`}
          />
          <span>*</span>
        </div>
        {error?.message && (
          <span className="alert alert-danger py-1">{error.message}</span>
        )}
      </div>
    </div>
  );
}
